
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutj79npaG_o5X0f0Of0y9GAPtpVnKzoVaNzkHr7ffGWrMMeta } from "/vercel/path0/nuxt-app/pages/about.vue?macro=true";
import { default as indexvyNtEwaktRoLh_XfM3Z0L1xpLr59VU5gwOVSewEEPfcMeta } from "/vercel/path0/nuxt-app/pages/index.vue?macro=true";
import { default as login2FsMFESGG5XFjAeu1d_45EQI1NwdJ9w_Lffgf6R_453kiE4Meta } from "/vercel/path0/nuxt-app/pages/login.vue?macro=true";
import { default as guidesu2nn8Z0h18dNDBxingfVdPi1G6l78h0EeGLgdbO8aq0Meta } from "/vercel/path0/nuxt-app/pages/guides.vue?macro=true";
import { default as logout4b9AqkDVecfRB1_3P1YQv29D7jQU00p7DT6YDROunzsMeta } from "/vercel/path0/nuxt-app/pages/logout.vue?macro=true";
import { default as wizardAYL1D60dClKaTZNU1Gjm8dhitwCIbT2K8vKW9QchO4kMeta } from "/vercel/path0/nuxt-app/pages/wizard.vue?macro=true";
import { default as budgetsI8rzu_45stltN3L1Lyf0ZyeLL8E5c7ypTm6MeD07jJrnkMeta } from "/vercel/path0/nuxt-app/pages/budgets.vue?macro=true";
import { default as contacty8TWfv1UUjggBtu0NZeGVYwVrw6eNx_GOfrlVGDBcy4Meta } from "/vercel/path0/nuxt-app/pages/contact.vue?macro=true";
import { default as pricingNTxR7K9_pC6WS3V5HPXkf1XUKVGVRsDeYOX6LKgUrxQMeta } from "/vercel/path0/nuxt-app/pages/pricing.vue?macro=true";
import { default as sessionfcLnlCWYaX1pyWVGHy2CcGYsHWrhmecIYz0jz1FEPzoMeta } from "/vercel/path0/nuxt-app/pages/session.vue?macro=true";
import { default as registerU97gDxOwBIZmW8WubOeTYwUzWJCi0KHmVF9Au2ud8vsMeta } from "/vercel/path0/nuxt-app/pages/register.vue?macro=true";
import { default as settingsf08sjkAwkpg9Z0QSo10KVL_45Q3eRrXQlErj6NrLf24XUMeta } from "/vercel/path0/nuxt-app/pages/settings.vue?macro=true";
import { default as erroroNhcOQZBFH14_rIRu1xVLfKkO0u5Kl0Mfl8VVmCaqBEMeta } from "/vercel/path0/nuxt-app/pages/auth/error.vue?macro=true";
import { default as indexr_4554Ak1Opr390g0C19w4lnfNNfOCkWJaRtyuFBy8RPYMeta } from "/vercel/path0/nuxt-app/pages/blog/index.vue?macro=true";
import { default as error_45testCgYa82f5uRYnRHknYKVXbQHj7KVFYY_45AKoZylY7RpvkMeta } from "/vercel/path0/nuxt-app/pages/error-test.vue?macro=true";
import { default as indexdYs62jMAkC11IxgiYeTY_IisA1VhsiMPPetNSxhYQMoMeta } from "/vercel/path0/nuxt-app/pages/admin/index.vue?macro=true";
import { default as usersBx5aPe_45Dqi95UEh1WYX5nC0L8XQT3XN7L3fucv5fmokMeta } from "/vercel/path0/nuxt-app/pages/admin/users.vue?macro=true";
import { default as check_45emailFUwgCRnSWTcAp5nonwZLj_45bFAZLPsJ4LvUSKjDIBL5AMeta } from "/vercel/path0/nuxt-app/pages/check-email.vue?macro=true";
import { default as choose_45plang9tamEUsTxOOxeKXks2TOSgMTKvdrvFleenT_Rs4lcoMeta } from "/vercel/path0/nuxt-app/pages/choose-plan.vue?macro=true";
import { default as investmentstGm_v9kxuMQox3vbVAUWWqNsJ4Px9HHAcxe8nBKsYXMMeta } from "/vercel/path0/nuxt-app/pages/investments.vue?macro=true";
import { default as unsubscribex7mbPdiw43bhp7bfJ3_45a8y8b2FkaASZb4cpLBxNsbAQMeta } from "/vercel/path0/nuxt-app/pages/unsubscribe.vue?macro=true";
import { default as accept_45terms2DMI7kT_45RCq483dox36qB8eWkZQEoTKr2EDnl6aPPDAMeta } from "/vercel/path0/nuxt-app/pages/accept-terms.vue?macro=true";
import { default as guidesBOiLAp7MbDv0VHXHo5DtjWL_459oI0zFaeisGJbNrs_4578Meta } from "/vercel/path0/nuxt-app/pages/admin/guides.vue?macro=true";
import { default as debt_45plannersZI0o1B_eW2m8_45vaynBKDgXXhWRpcu4NiGy1TCI64k0Meta } from "/vercel/path0/nuxt-app/pages/debt-planner.vue?macro=true";
import { default as setup_45wizardayI885T_45izxrxhhku5A_45tLLFxVI_KH_kJFJ19cP7DbwMeta } from "/vercel/path0/nuxt-app/pages/setup-wizard.vue?macro=true";
import { default as feedbackKrv5vEk2clfOnaQYrPUCfHPNpo_45dVwO1HjY7C61GNecMeta } from "/vercel/path0/nuxt-app/pages/admin/feedback.vue?macro=true";
import { default as _91_46_46_46slug_935JA9qufKcDffDV1sxga_W_AQJmBOY_45PlPWH2YZlywsMMeta } from "/vercel/path0/nuxt-app/pages/blog/[...slug].vue?macro=true";
import { default as emergency_45fundri8FPzA2B2KUqoL1gAhK8d9HmzidLPw1cC6FkJ36WDAMeta } from "/vercel/path0/nuxt-app/pages/emergency-fund.vue?macro=true";
import { default as privacy_45policyKT9lHDy_45BhTjZZ1bppjNVHHW45tBhZf9mYTFUeXm3M4Meta } from "/vercel/path0/nuxt-app/pages/privacy-policy.vue?macro=true";
import { default as protected_45pageoVXHC38CTJU4jwSONzjOqWcvKLDY7GC1RTPZeqvWJBoMeta } from "/vercel/path0/nuxt-app/pages/protected-page.vue?macro=true";
import { default as analyticseiZ1atPsfIdy2J_45cmbXNWIc29JuybTfdnkYiHNnvCtYMeta } from "/vercel/path0/nuxt-app/pages/admin/analytics.vue?macro=true";
import { default as deposit_45trackerdlNLbxrRjSoJfK682kC_4gsI3zQfiCYs5DZpoV_45sudsMeta } from "/vercel/path0/nuxt-app/pages/deposit-tracker.vue?macro=true";
import { default as terms_45of_45servicekKk8ZDZYeMfVc6kMLBniv9Vhb0Rih6UbdpcAGM98wbYMeta } from "/vercel/path0/nuxt-app/pages/terms-of-service.vue?macro=true";
import { default as email_45campaigns18DJGYCEls_IzwO2QKRLWyP_B3JeVwKCUN9cxOYjCX0Meta } from "/vercel/path0/nuxt-app/pages/admin/email-campaigns.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/vercel/path0/nuxt-app/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/nuxt-app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/vercel/path0/nuxt-app/pages/login.vue")
  },
  {
    name: "guides",
    path: "/guides",
    component: () => import("/vercel/path0/nuxt-app/pages/guides.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/vercel/path0/nuxt-app/pages/logout.vue")
  },
  {
    name: "wizard",
    path: "/wizard",
    component: () => import("/vercel/path0/nuxt-app/pages/wizard.vue")
  },
  {
    name: "budgets",
    path: "/budgets",
    meta: budgetsI8rzu_45stltN3L1Lyf0ZyeLL8E5c7ypTm6MeD07jJrnkMeta || {},
    component: () => import("/vercel/path0/nuxt-app/pages/budgets.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/vercel/path0/nuxt-app/pages/contact.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/vercel/path0/nuxt-app/pages/pricing.vue")
  },
  {
    name: "session",
    path: "/session",
    component: () => import("/vercel/path0/nuxt-app/pages/session.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/vercel/path0/nuxt-app/pages/register.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/vercel/path0/nuxt-app/pages/settings.vue")
  },
  {
    name: "auth-error",
    path: "/auth/error",
    component: () => import("/vercel/path0/nuxt-app/pages/auth/error.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/vercel/path0/nuxt-app/pages/blog/index.vue")
  },
  {
    name: "error-test",
    path: "/error-test",
    component: () => import("/vercel/path0/nuxt-app/pages/error-test.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: {"middleware":"admin"},
    component: () => import("/vercel/path0/nuxt-app/pages/admin/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: {"middleware":["admin"]},
    component: () => import("/vercel/path0/nuxt-app/pages/admin/users.vue")
  },
  {
    name: "check-email",
    path: "/check-email",
    meta: check_45emailFUwgCRnSWTcAp5nonwZLj_45bFAZLPsJ4LvUSKjDIBL5AMeta || {},
    component: () => import("/vercel/path0/nuxt-app/pages/check-email.vue")
  },
  {
    name: "choose-plan",
    path: "/choose-plan",
    component: () => import("/vercel/path0/nuxt-app/pages/choose-plan.vue")
  },
  {
    name: "investments",
    path: "/investments",
    component: () => import("/vercel/path0/nuxt-app/pages/investments.vue")
  },
  {
    name: "unsubscribe",
    path: "/unsubscribe",
    component: () => import("/vercel/path0/nuxt-app/pages/unsubscribe.vue")
  },
  {
    name: "accept-terms",
    path: "/accept-terms",
    meta: { ...(accept_45terms2DMI7kT_45RCq483dox36qB8eWkZQEoTKr2EDnl6aPPDAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/vercel/path0/nuxt-app/pages/accept-terms.vue")
  },
  {
    name: "admin-guides",
    path: "/admin/guides",
    meta: {"middleware":["admin"]},
    component: () => import("/vercel/path0/nuxt-app/pages/admin/guides.vue")
  },
  {
    name: "debt-planner",
    path: "/debt-planner",
    meta: debt_45plannersZI0o1B_eW2m8_45vaynBKDgXXhWRpcu4NiGy1TCI64k0Meta || {},
    component: () => import("/vercel/path0/nuxt-app/pages/debt-planner.vue")
  },
  {
    name: "setup-wizard",
    path: "/setup-wizard",
    component: () => import("/vercel/path0/nuxt-app/pages/setup-wizard.vue")
  },
  {
    name: "admin-feedback",
    path: "/admin/feedback",
    meta: {"middleware":["admin"]},
    component: () => import("/vercel/path0/nuxt-app/pages/admin/feedback.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug(.*)*",
    component: () => import("/vercel/path0/nuxt-app/pages/blog/[...slug].vue")
  },
  {
    name: "emergency-fund",
    path: "/emergency-fund",
    component: () => import("/vercel/path0/nuxt-app/pages/emergency-fund.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/vercel/path0/nuxt-app/pages/privacy-policy.vue")
  },
  {
    name: "protected-page",
    path: "/protected-page",
    meta: protected_45pageoVXHC38CTJU4jwSONzjOqWcvKLDY7GC1RTPZeqvWJBoMeta || {},
    component: () => import("/vercel/path0/nuxt-app/pages/protected-page.vue")
  },
  {
    name: "admin-analytics",
    path: "/admin/analytics",
    meta: {"middleware":"admin"},
    component: () => import("/vercel/path0/nuxt-app/pages/admin/analytics.vue")
  },
  {
    name: "deposit-tracker",
    path: "/deposit-tracker",
    component: () => import("/vercel/path0/nuxt-app/pages/deposit-tracker.vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    component: () => import("/vercel/path0/nuxt-app/pages/terms-of-service.vue")
  },
  {
    name: "admin-email-campaigns",
    path: "/admin/email-campaigns",
    meta: { ...(email_45campaigns18DJGYCEls_IzwO2QKRLWyP_B3JeVwKCUN9cxOYjCX0Meta || {}), ...{"middleware":"admin"} },
    component: () => import("/vercel/path0/nuxt-app/pages/admin/email-campaigns.vue")
  }
]